(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-lp"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_03"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_04"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_06"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_07"]) return;
  try {
    
   // スムーススクロール
  const anchors = document.querySelectorAll('a[href^="#"]');

  for ( let i = 0; i < anchors.length; i++ ) {
    anchors[i].addEventListener('click', (e) => {
      e.preventDefault();
      const href= anchors[i].getAttribute("href");

      if (href !== '#top') {
        const target = document.getElementById(href.replace('#', ''));
        const position = window.pageYOffset + target.getBoundingClientRect().top;

        window.scroll({
          top: position,
          behavior: 'smooth'
        });
      } else {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });

      }
    });
  }

   $(".recommend-slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '27.5%',
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_08"]) return;
  try {
    
   // スムーススクロール
  const anchors = document.querySelectorAll('a[href^="#"]');

  for ( let i = 0; i < anchors.length; i++ ) {
    anchors[i].addEventListener('click', (e) => {
      e.preventDefault();
      const href= anchors[i].getAttribute("href");

      if (href !== '#top') {
        const target = document.getElementById(href.replace('#', ''));
        const position = window.pageYOffset + target.getBoundingClientRect().top;

        window.scroll({
          top: position,
          behavior: 'smooth'
        });
      } else {
        window.scroll({
          top: 0,
          behavior: 'smooth'
        });

      }
    });
  }

  $(".recommend-slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '27.5%',
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_10"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-lp_11"]) return;
  try {
    
  $(".slider").slick({
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    swipe: true,
    arrows: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    centerMode: true,
    centerPadding: '19%',
  });
  
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
